import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f0f658f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = { class: "modal-container" }
const _hoisted_3 = { class: "modal-title warning" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Cancel")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Confirm")


import { Button as KButton } from "@progress/kendo-vue-buttons";

type Props = {
  show: boolean;
  title: string;
  bodyText: string;
};


const __default__ = {
  name: "GenericConfirmModal",
  inheritAttrs: false,
  customOptions: {},
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    show: { type: Boolean },
    title: null,
    bodyText: null
  },
  emits: ["confirmed", "cancelled", "closed"],
  setup(__props: any, { emit }) {

const props = __props as {
  show: boolean;
  title: string;
  bodyText: string;
}




const onBackDropClick = () => emit("closed");
const onCancel = () => emit("cancelled");
const onConfirm = () => emit("confirmed");

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "modal" }, {
    default: _withCtx(() => [
      (props.show)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "modal-mask",
            onClick: onBackDropClick
          }, [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("header", null, [
                  _createElementVNode("h1", _hoisted_3, _toDisplayString(props.title), 1)
                ]),
                _createElementVNode("main", null, [
                  _renderSlot(_ctx.$slots, "main")
                ]),
                _createElementVNode("footer", null, [
                  _createVNode(_unref(KButton), {
                    class: "action danger",
                    onClick: onCancel
                  }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_unref(KButton), {
                    class: "action primary",
                    onClick: onConfirm
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  })
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})